import React from 'react';
import { connect } from 'react-redux';
import hexToRgba from 'hex-to-rgba';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LanguageDropdown from './LanguageDropdown';

const CampusBackground = ({
  children,
  column,
  secondaryColor,
  tenant,
  optRef,
  showLangDropdown = false,
}) => {
  const secondaryBackground = {
    backgroundColor: hexToRgba(secondaryColor, '0.8'),
  };

  const heroImg = ({ hero }) => {
    // console.log('hero', hero);
    return `url(${hero})`;
  };

  return (
    <section className="campus-background" ref={optRef}>
      <div
        className="campus-background-image"
        style={{ backgroundImage: heroImg(tenant) }}
      >
        <div
          className="campus-background-image-overlay"
          style={secondaryBackground}
        />
      </div>
      <div
        className={classNames({
          'campus-background-content': true,
          'campus-background-content--column': column,
        })}
      >
        {children}
      </div>
      <div
        className="campus-background-dropdown-wrapper"
        hidden={!showLangDropdown}
      >
        <LanguageDropdown />
      </div>
    </section>
  );
};

CampusBackground.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  secondaryColor: PropTypes.string.isRequired,
  column: PropTypes.bool,
  optRef: PropTypes.any,
};

const mapStateToProps = (state) => {
  const tenant = state.tenant;

  return { tenant };
};

export default connect(mapStateToProps, {})(CampusBackground);
